


















import {Component, Prop, Vue} from 'vue-property-decorator'
import * as WF from '@/components/widgets/WidgetFather'

interface Pos {
  x: number,
  y: number
}

@Component({})
export default class WidgetMenu extends Vue {
  @Prop() public widgets!: WF.WidgetCategoryDef[]
  @Prop() public dndPos!: Pos
  private pos: Pos = {x: 0, y: 0}

  public created() {
    // setup widget category submenu visibility
    // initially make only first category visible
    // let show = true
    this.widgets.forEach((item) => {
      item.show = false
      // show = false
    })
  }

  public toggleCategory(clickIndex: number) {
    this.widgets.forEach((cat, index)=>{
      index === clickIndex && (cat.show = !cat.show)
      index !== clickIndex && (cat.show = false)
    })
  }

  public getIcon(w: WF.WidgetDefinition): string {
    const icon = w._icon || ''
    const iconImage = icon in WF.WidgetIcons ? WF.WidgetIcons[icon] : WF.WidgetIcons["pie"]
    const images = require.context('../assets/micad/images/', false, /\.png$/)
    return images('./' + iconImage)
  }

  public registerDrag(w: WF.WidgetDefinition): string {
    let that = this
    let id = w.widget
    this.$nextTick(() => {
      dragElement(id, this.dndPos)
    })
    return id

    function dragElement(id: string, dnd: Pos) {
      let el = document.getElementById(id)
      const content = document.getElementById('standardLayoutContentBox') as HTMLElement
      const sideNavBox = document.getElementById('sideNavBox') as HTMLElement
      const dndGrid = document.getElementById('dndGrid') as HTMLElement
      const html = document.getElementById('html') as HTMLElement

      let dragPlaceholder = document.getElementById('widgetDragPlaceholder') as HTMLElement
      dragPlaceholder.style.left = '0px'
      let xDiff = 0, yDiff = 0, mouseDownX = 0, mouseDownY = 0
      el && (el.onmousedown = dragMouseDown)

      function dragMouseDown(e: any) {
        dragPlaceholder.style.width = (w.w * WF.Grid.cellWidth) + 'px'
        dragPlaceholder.style.height = (w.h * WF.Grid.cellHeight) + 'px'
        that.$emit('start-drag', id)
        dragPlaceholder.style.left = e.clientX + 'px'
        dragPlaceholder.style.top = e.clientY + 'px'
        e = e || window.event
        e.preventDefault()
        // get the mouse cursor position at startup:
        mouseDownX = e.clientX
        mouseDownY = e.clientY
        document.onmouseup = closeDragElement
        // call a function whenever the cursor moves:
        document.onmousemove = elementDrag
        dragPlaceholder.style.display = 'block'
        let dndX = e.clientX - sideNavBox.offsetLeft - content.offsetLeft
        let dndY = e.clientY - content.offsetTop + content.scrollTop + html.scrollTop
        dragPlaceholder.style.left = dndX + 'px'
        dragPlaceholder.style.top = dndY + 'px'
        that.pos.x = dndX
        that.pos.y = dndY
      }

      function elementDrag(e: any) {
        e = e || window.event
        e.preventDefault()
        // calculate the new cursor position:
        xDiff = mouseDownX - e.clientX
        yDiff = mouseDownY - e.clientY
        mouseDownX = e.clientX
        mouseDownY = e.clientY
        // set the element's new position:

        dragPlaceholder.style.top = (dragPlaceholder.offsetTop - yDiff) + "px"
        dragPlaceholder.style.left = (dragPlaceholder.offsetLeft - xDiff) + "px"
        dnd.x = parseInt(dragPlaceholder.style.left)
        dnd.y = parseInt(dragPlaceholder.style.top) + dndGrid.scrollTop
      }

      function closeDragElement() {
        that.$emit('stop-drag')
        // stop moving when mouse button is released:
        document.onmouseup = null
        document.onmousemove = null
        dragPlaceholder.style.display = 'none'
      }
    }
  }
}
